import CallUs from 'features/help/screens/CallUs';
import React from 'react';

export default function CallUsPage() {
  return <CallUs />;
}
